__turbopack_context__.v({
  "leftNavItem": "LeftNavItem-module__Tl0N8a__leftNavItem",
  "leftNavItemActive": "LeftNavItem-module__Tl0N8a__leftNavItemActive",
  "leftNavItemDisabled": "LeftNavItem-module__Tl0N8a__leftNavItemDisabled",
  "leftNavItem__back": "LeftNavItem-module__Tl0N8a__leftNavItem__back",
  "leftNavItem__backNormal": "LeftNavItem-module__Tl0N8a__leftNavItem__backNormal",
  "leftNavItem__flair": "LeftNavItem-module__Tl0N8a__leftNavItem__flair",
  "leftNavItem__separator": "LeftNavItem-module__Tl0N8a__leftNavItem__separator",
  "leftNavItem__title": "LeftNavItem-module__Tl0N8a__leftNavItem__title",
});
